module.exports = __webpack_public_path__ + "media/images/logo-icon-35ca2010b98a847732fde953a1b7201c.svg";